const axios = require("axios");
axios.defaults.withCredentials = true;
const client = axios.create({
  transformRequest: [
    function (data, headers) {
      console.log(data)
      let flag = true;
      for (let key in data) {
        if (typeof data[key] == "string") {
          if (data[key].includes("<script>")) {
            flag = false;
          }
        }
      }
      if (flag) {
        return JSON.stringify({ ...data });
      } else {
        throw new Error("Validation Error: Invalid input field");
      }
    },
  ],
});

export default client;
